export default __webpack_public_path__ + "static/media/OSad.bf449e1a.svg";